import { NicheArea } from "./types";

// The interview's six topics, in the order the api asks them.
export const NICHE_TOPICS: ReadonlyArray<{ area: NicheArea; name: string; line: string }> = [
    { area: "clients", name: "Your clients", line: "Let's get started!" },
    { area: "expertise", name: "What you know best", line: "Great start!" },
    { area: "lifeStage", name: "Your clients' life stage", line: "You're on a roll." },
    { area: "homeBase", name: "Your home base", line: "Halfway there!" },
    { area: "serviceAreas", name: "Areas you serve", line: "Almost there! Just 2 topics to go" },
    { area: "difference", name: "What sets you apart", line: "Last one!" },
];

const FOLLOW_UP_LINE = "Quick follow-up on that - then we move on.";

export interface InterviewStep {
    number: number;
    name: string;
    followUp: boolean;
    line: string;
}

// Topics are covered in order and the AI only follows up on the topic just answered, so a
// question is a follow-up exactly when its topic already has an answer (is within `covered`).
export const interviewStep = (area: NicheArea, covered: number): InterviewStep | null => {
    const i = NICHE_TOPICS.findIndex((t) => t.area === area);
    if (i < 0) return null;
    const followUp = i < covered;
    return { number: i + 1, name: NICHE_TOPICS[i].name, followUp, line: followUp ? FOLLOW_UP_LINE : NICHE_TOPICS[i].line };
};

// The step of the question at `index` in an interview's turns (asked order): a follow-up when its
// topic already has an answered question before it. Every bot bubble in the transcript uses it.
export const turnStep = (turns: ReadonlyArray<{ area: NicheArea; answer?: string }>, index: number): InterviewStep | null => {
    if (index < 0 || index >= turns.length) return null;
    const answered = new Set(turns.slice(0, index).filter((t) => t.answer).map((t) => t.area));
    return interviewStep(turns[index].area, answered.size);
};
